import { render } from "./CloseSection.vue?vue&type=template&id=58253b2c"
import script from "./CloseSection.vue?vue&type=script&lang=js"
export * from "./CloseSection.vue?vue&type=script&lang=js"
script.render = render

export default script